import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { matchPath } from 'react-router'
import classnames from 'classnames'
import SVG from 'react-inlinesvg'
import _ from 'lodash'

const themes = {
  default: null
}

const pill = (index, route, { content, active, icon, ...rest }) => {
  let isCurrentPath;

  if (active === null || active === undefined) {
    const { location } = route
    const { to } = rest

    isCurrentPath = !!matchPath(location.pathname, { path: to, exact: true })
  }
  else { isCurrentPath = active }

  const classes = classnames("pills__item", {
    "pills__item--active": !!isCurrentPath
  })

  return (
    <Link key={index} className={classes} {...rest}>
      { typeof content === 'function' ? content() : (content || <SVG src={icon} />) }
    </Link>
  )
}

const Pills = ({ theme, route, items, className }) => {
  const enabledItems = _.filter(items, (item) => {
    return !!_.defaultTo(item.disabled, false) == false
  })

  return (
    <div className={classnames("pills", themes[theme], className)}>
      { _.map(enabledItems, (item, index) => pill(index, route, item)) }
    </div>
  )
}

Pills.propTypes = {
  items: PropTypes.array.isRequired,
  route: PropTypes.object
}

Pills.defaultProps = {
  theme: "default"
}

export default Pills
